import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 50%',
        maxWidth: '50%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '50vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .menu-item, .header-phone-link': {
      fontSize: '16px !important',
    },
    '& .topbar-listitem': {
      padding: '0px 10px !important',
    },
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
  },

  '.group-parent-container': {
    '& .home-static-hero-wrapper': {
      '& .MuiButton-containedPrimary': {
        color: palette.text.highlight,
        '&:hover': {
          backgroundColor: `${palette.text.highlight} !important`,
          color: `${palette.text.brand} !important`,
        },
      },
    },
    '& .normal-text': {
      fontWeight: 500,
      fontFamily: 'Montserrat !important',
      fontSize: '64px !important',
      lineHeight: '72px !important',
      letterSpacing: '-0.64px !important',
      '@media (min-width: 600px) and (max-width: 1024px)': {
        fontSize: '52px !important',
        lineHeight: '64px !important',
        letterSpacing: '-1.04px !important',
      },
      '@media (max-width: 600px)': {
        fontSize: '44px !important',
        lineHeight: '48px !important',
        letterSpacing: '-0.88px !important',
      },
    },
    '& .hero-home-button': {
      color: palette.text.highlight,
      borderColor: palette.text.highlight,

      '&:hover': {
        borderColor: palette.text.highlight,
      },
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      marginTop: 88,
      borderColor: palette.primary.main,
      background: palette.primary.main,
      '& .hero-header-title': {
      color: palette.text.highlight,
        fontFamily: 'Montserrat !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 500,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'Inter Display !important',
        fontSize: '20px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 400,
      },


      '& h1,& h2,& h3,& h4,& p': {
        color: palette.text.highlight,
      },
    },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
      },
      '& .MuiSwitch-track': {
        border: 'none',
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
      '& .success-wrapper': {
        '& .MuiButton-containedPrimary': {
          backgroundColor: palette.text.highlight,
          color: palette.text.primary,
          border: `1px solid ${palette.primary.main}`,
        },
      },
    },

    '& .topbar-listitem': {
      '& .MuiButtonBase-root': {
        textTransform: 'none',
      },
    },

    /* Hero Section - Styles */
    '& .home-hero-variant-2': {
      marginTop: '80px',
    },
    '& .home-hero-wrapper': {
      overflow: 'hidden',
      '@media(max-width: 1200px) and (min-width: 900px)': {
        maxHeight: '600px !important',
      },
      '@media(max-width: 600px)': {
        backgroundColor: palette.background.fill,
        paddingTop: '40px !important',
      },
      /* hero-background: right-column image — no width override so component controls placement */
      '& .hero-background': {
        objectFit: 'cover',
        objectPosition: 'right center',
        backgroundColor: palette.background.fill,
        '@media screen and (max-width: 600px)': {
          height: '440px',
        },
        '@media screen and (min-width: 1800px)': {
          objectFit: 'contain',
        },
      },
      /* image-wrapper + image: fills the full right column with no gaps */
      '& .image-wrapper': {
        padding: '0 !important',
        margin: '0 !important',
        width: '100% !important',
        maxWidth: '100% !important',
        overflow: 'hidden',
        display: 'block !important',
        position: 'relative',
        backgroundColor: palette.background.fill,
        '@media(max-width: 1024px) and (min-width: 900px)': {
          height: '600px !important',
        },
        '& .image': {
          borderRadius: '0 !important',
          boxShadow: 'none !important',
          padding: '0 !important',
          margin: '0 !important',
          display: 'block !important',
          left: '15% !important',
          '@media(min-width: 900px)': {
            width: '100% !important',
            height: '600px !important',
            objectFit: 'cover !important',
            objectPosition: 'center center !important',
          },
          '@media(max-width: 1024px) and (min-width: 900px)': {
            position: 'absolute !important',
            left: '15% !important',
            width: '115% !important',
            height: '600px !important',
            objectFit: 'cover !important',
            objectPosition: 'center center !important',
          },
          '@media(max-width: 900px) and (min-width: 600px)': {
            width: '100% !important',
            height: '400px !important',
            objectFit: 'cover !important',
            objectPosition: 'center center !important',
          },
          '@media(max-width: 600px)': {
            width: '100% !important',
            height: '300px !important',
            objectFit: 'cover !important',
          },
          '@media screen and (min-width: 1800px)': {
            height: '700px !important',
          },
        },
      },
      /* hero-section: standard layout (no verticalAlignImage) */
      '& .hero-section': {
        display: 'flex',
        alignItems: 'stretch !important',
        maxHeight: '700px',
        overflow: 'hidden',
        '& .section-alternate__content': {
          backgroundColor: palette.background.fill,
          paddingRight: '0px !important',
          '@media(max-width: 1200px)': {
            width: '100% !important',
            padding: '0px 50px !important',
            paddingRight: '0px !important',
          },
          '@media(max-width: 600px)': {
            padding: '0px 10px !important',
          },
        },
        '& .section-header': {
          '@media screen and (min-width: 768px)': {
            marginTop: '60px',
          },
          '& .section-header__cta-container': {
            '@media(max-width: 600px)': {
              justifyContent: 'center !important',
            },
          },
          '& .section-header__title-wrapper': {
            paddingBottom: '24px !important',
          },
        },
      },
      /* hero-section-alternate: fallback if component still uses alternate layout */
      '& .hero-section-alternate': {
        alignItems: 'stretch !important',
        height: 'auto !important',
        paddingBottom: 0,
        overflow: 'hidden',
        '& .section-alternate__content': {
          backgroundColor: palette.background.fill,
          paddingRight: '0px !important',
          '@media(max-width: 1200px)': {
            width: '100% !important',
            padding: '0px 50px !important',
            paddingRight: '0px !important',
          },
          '@media(max-width: 600px)': {
            padding: '0px 10px !important',
          },
        },
      },
      '& .home-hero-title': {
        fontSize: '64px !important',
        fontFamily: 'Montserrat',
        maxWidth: 634,
        lineHeight: '72px !important',
        letterSpacing: '-1.28px',
        '@media(max-width: 1024px) and (min-width: 600px)': {
          fontSize: '52px !important',
          lineHeight: '64px !important',
          letterSpacing: '-1.04px !important',
        },
        '@media(max-width: 600px)': {
          lineHeight: '48px !important',
          fontSize: '44px !important',
          letterSpacing: '-0.72px !important',
          textAlign: 'center !important',
        },
      },
      '& .home-hero-subtitle': {
        maxWidth: 550,
        lineHeight: '28px !important',
        fontSize: '24px !important',
        letterSpacing: '-0.48px !important',
        color: palette.text.secondary,
        '@media(max-width: 600px)': {
          fontSize: '18px !important',
          textAlign: 'center !important',
        },
      },
      '@media screen and (max-width: 900px)': {
        '& .home-hero-title': {
          fontSize: '2.5rem !important',
        },
        '& .home-hero-subtitle': {
          fontSize: 16,
          maxWidth: 550,
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      background: palette.surface.grey,
      '& .definition-variant-2': {
        paddingInline: '56px !important',
        '@media(max-width: 600px)': {
          paddingInline: '10px !important',
          paddingTop: '10px !important',
        },
        '@media(min-width: 600px) and (max-width: 900px)': {
          padding: '20px !important',
        },
      },
      '@media(max-width: 1200px) and (min-width: 600px)': {
        padding: ' 0px 20px !important',
      },
      '& .benefits-wrapper': {
        '& .customImageWrapper': {
          display: 'flex !important',
          justifyContent: 'center',
          alignItems: 'stretch',
          width: '100% !important',
          overflow: 'hidden',
          position: 'relative',
          '@media(max-width: 600px)': {
            height: '382px !important',
            minHeight: '382px !important',
          },
          '@media(min-width: 600px) and (max-width: 1200px)': {
            height: '400px !important',
            minHeight: '400px !important',
          },
          '@media(min-width: 1200px)': {
            height: '800px !important',
            minHeight: '800px !important',
          },
          '& .lazy-load-image-background': {
            width: '100% !important',
            height: '100% !important',
            minHeight: '100% !important',
            display: 'block !important',
            position: 'relative',
            borderRadius: '12px',
            overflow: 'hidden',
            '& img, & .image': {
              width: '100% !important',
              height: '100% !important',
              minHeight: '100% !important',
              objectFit: 'cover !important',
              display: 'block !important',
              position: 'absolute',
              top: 0,
              left: 0,
              borderRadius: '24px',
            },
          },
          '& img, & .image': {
            width: '100% !important',
            height: '100% !important',
            minHeight: '100% !important',
            objectFit: 'cover !important',
            display: 'block !important',
            borderRadius: '24px',
          },
        },
      },
      '& .section-alternate__content': {
        padding: '48px 16px',

        '@media (min-width: 600px)': {
          padding: '48px 16px',
        },
        '@media (min-width: 900px) and (max-width: 1200px)': {
          padding: '0px 0px 0px',
        },
        '@media (min-width: 1200px)': {
          padding: '0px 48px 0px',
        },

      },
      '& .definition-service-tile': {
        '& .definition-service-innertile': {
          justifyContent: 'left !important',
        },
        '@media(min-width: 900px)': {
          maxWidth: '420px !important',
        },
        '@media(max-width: 900px)': {
          paddingBottom: '30px !important',
          paddingTop: '30px !important',
        },
      },
      '& .definition-benefits-grid': {
        justifyContent: 'space-between',
      },
      '& .definition-services-grid': {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 24,
        justifyContent: 'center',
        alignItems: 'stretch',

        '@media screen and (max-width: 900px)': {
          gridTemplateColumns: '1fr',
        },
      },
      '& .definition-services-grid': {
        paddingTop: '16px !important',
      },
      '& .MuiCardContent-root': {
        padding: 32,
      },
      '& .definition-service-header': {
        justifyContent: 'flex-end',
        flexDirection: 'row-reverse',
        marginBottom: 24,
      },
      '& .definition-service-title': {
        fontWeight: 500,
        color: palette.text.secondary,
        fontFamily: 'Montserrat !important',
        fontSize: '24px !important',
        lineHeight: '28px !important',
        letterSpacing: '-1.4px !important',
        textAlign: 'left !important',
        paddingBottom: '10px !important',
        '@media(max-width: 600px)': {
          fontSize: '24px !important',
          letterSpacing: '-1.2px !important',
        },
      },

      '& .customIcon': {
        justifyContent: 'left !important',
        paddingBottom: '30px !important',
      },
      '& .definition-service-description': {
        marginBottom: 0,
        fontSize: '18px !important',
        lineHeight: '22px !important',
        color: palette.text.tertiaryLight,
        textAlign: 'left !important',
        letterSpacing: '-0.36px !important',
      },
      '& .section-header__title': {
        fontWeight: 500,
        whiteSpace: 'pre-line',
        fontFamily: 'Montserrat !important',
        fontSize: '52px !important',
        lineHeight: '56px !important',
        letterSpacing: '-1.04px !important',
        paddingBottom: '24px !important',
        textAlign: 'left !important',
        '@media(max-width: 900px)': {
          paddingBottom: '0px !important',
        },
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '48px !important',
          letterSpacing: '-0.96px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '44px !important',
          lineHeight: '44px !important',
          letterSpacing: '-0.88px !important',
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      padding: '0px 16px !important',
      '& .subscription-bg': {
        height: '100%',
        background: palette.surface.main,
      },
      '& .section-header__title, .summary-text, .summary-subtext, .subscription-tabs-label':{
        color: `${palette.text.highlight} !important`,
      },
      '& .section-header__title': {
        fontWeight: 500,
        fontFamily: 'Montserrat !important',
        fontSize: '56px !important',
        lineHeight: '76px !important',
        letterSpacing: '-1.68px !important',
        whiteSpace: 'pre-line',
        '@media screen and (max-width: 900px) and (min-width: 600px)': {
          fontSize: '56px !important',
          lineHeight: '68px !important',
          letterSpacing: '-1.68px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '44px !important',
          lineHeight: '48px !important',
          letterSpacing: '-1.44px !important',
        },
      },
      '& .section-header__subtitle': {
        fontWeight: 400,
        fontFamily: 'Inter Display !important',
        fontSize: '22px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.72px !important',
        color: palette.text.highlight,
        '@media screen and (max-width: 900px)': {
          fontSize: '22px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.66px !important',
        },
      },
      '& .summary-text': {
        fontWeight: 400,
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          width: '100% !important',
          fontWeight: 400,
          '& .MuiTypography-body2': {
            fontSize: '14px !important',
            lineHeight: '20px !important',
            letterSpacing: '-0.32px !important',
          },
          borderRadius: '12px !important',
          border: 'none !important',
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
            '& hr': {
              color: palette.text.secondary,
            },
          },
          '& .customSubscriberName': {
            color: palette.text.secondary,
          },
          '& .MuiButton-containedPrimary': {
            backgroundColor: palette.primary.light,
            color: palette.text.tertiary,
            '&:hover': {
              backgroundColor: palette.secondary.main,
              color: palette.text.highlight,
              transition: 'none !important',
            },
          },
          '& .customcardTitle': {
            fontWeight: 500,
            fontFamily: 'Montserrat !important',
            fontSize: '24px !important',
            lineHeight: '32px !important',
            letterSpacing: '-1.4px !important',
            color: palette.text.tertiary,
          },
          '& .price-value': {
            fontWeight: 600,
            fontSize: '32px !important',
            fontFamily: 'Montserrat !important',
            lineHeight: '40px !important',
            letterSpacing: '-0.8px !important',
            color: palette.text.primary,
            '@media screen and (max-width: 700px)': {
              fontSize: '32px !important',
              lineHeight: '32px !important',
              letterSpacing: '-0.64px !important',
            },
          },
          '& .customUpfrontWrapper': {
            color: palette.text.tertiaryLight,
            fontWeight: 400,
            lineHeight: '16px !important',
            letterSpacing: '-0.42px !important',
            fontStyle: 'italic',
          },
        },
        '& .disclaimerContainer': {
            '& .customUpfrontWrapper': {
              paddingLeft: '15px !important',
              width: '100% !important',
            },
            '& .disclaimerText': {
              fontSize: '14px !important',
              color: palette.text.tertiary,
            },
            '& .bold': {
              fontSize: '14px !important',
              lineHeight: '20px !important',
              color: `${palette.text.tertiary} !important`,
              fontStyle: 'italic',
              fontFamily: 'Inter Display !important',
            },
          },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
            '@media(max-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
        },
        '& .bold': {
          fontWeight: 500,
          fontSize: '24px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
          color: `${palette.text.secondary} !important`,
          fontFamily: 'Montserrat !important',
        },
        '& .summary-text': {
          fontWeight: 500,
          fontSize: '22px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.72px !important',
          fontFamily: 'Inter Display !important',
          color: `${palette.text.highlight} !important`,
        },
        '& .summary-subtext': {
          fontWeight: 500,
          fontSize: '22px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.72px !important',
          color: `${palette.text.highlight} !important`,
        },
        '& .savings-summary-link': {
          color: `${palette.text.highlight} !important`,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
      '& .react-multi-carousel-dot--active': {
        '& button': {
          backgroundColor: palette.text.highlight,
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.background.main,
      '& .section': {
        '@media(min-width: 600px) and (max-width: 1024px)': {
          padding: '40px !important',
        },
        '@media(min-width: 1024px)': {
          padding: '40px 80px !important',
        },
        '@media(max-width: 600px)': {
          padding: '24px 20px !important',
        },
      },

      '& .cover-image-wrapper': {
        display: 'flex !important',
        justifyContent: 'center',
        alignItems: 'stretch',
        width: '100% !important',
        overflow: 'hidden',
        position: 'relative',
        borderRadius: '24px !important',
        '@media(min-width: 600px) and (max-width: 1024px)': {
          height: '500px !important',
          minHeight: '500px !important',
        },
        '@media(min-width: 1024px)': {
          height: '560px !important',
          minHeight: '560px !important',
        },
        '@media(max-width: 600px)': {
          height: '382px !important',
          minHeight: '382px !important',
        },
        '& img, & .image, & .how-cover-image': {
          width: '100% !important',
          height: '100% !important',
          minHeight: '100% !important',
          objectFit: 'cover !important',
          display: 'block !important',
          position: 'absolute',
          top: 0,
          left: 0,
        },
      },
      '& .howitworks-title': {
        '& .section-header__title': {
          whiteSpace: 'pre-line',
          fontFamily: 'Montserrat !important',
          fontSize: '52px !important',
          lineHeight: '56px !important',
          letterSpacing: '-1.04px !important',
          fontWeight: 500,
          '@media(min-width: 600px) and (max-width: 1200px)': {
            fontSize: '48px !important',
            letterSpacing: '-0.96px !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '44px !important',
            lineHeight: '44px !important',
            letterSpacing: '-0.88px !important',
          },
        },
        '& .section-header__subtitle': {
          fontWeight: 400,
          fontSize: '24px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.48px !important',
          '@media(max-width: 900px)': {
            fontSize: '22px !important',
            letterSpacing: '-0.8px !important',
          },
        },
        marginBottom: 40,
      },

      '& .howitworks-wrapper': {
        padding: 20,
      },

      '& .howitworks-wrapper-left': {
        padding: 20,
        paddingLeft: '0 !important',
        '@media(max-width: 1000px)': {
          paddingTop: '40px !important',
        },
      },

      '& .makeStyles-root-54': {
        padding: 0,
      },

      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.background.brand,
        color: palette.text.highlight,
        fontSize: 15,
      },

      '& .working-steps-container': {
        maxWidth: '560px',
        '&:not(:last-child)': {
          borderBottom: `1px solid ${palette.background.border} !important`,
        },
        '& .step-title': {
          fontSize: 24,
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
          fontFamily: 'Inter Display !important',
          paddingBottom: '8px !important',
        },
        '& .step-content': {
          fontSize: 18,
          color: palette.text.secondary,
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
          fontWeight: 400,
        },
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },

      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 18,
      },

      '@media screen and (max-width: 900px)': {
        '& .howitworks-wrapper-left': {
          padding: '5px',
        },
      },

      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '40px',
          paddingRight: '40px',
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-hero-section': {
        background: palette.surface.main,
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.secondary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 0px 0px 0px !important',
        backgroundColor: palette.surface.light,
        '& .contact-img-wrapper': {
          width: '64px',
          maxWidth: '64px',
          padding: '0px !important',
          marginRight: '8px !important',
        },
      },

      '& .footer-bar-text': {
        color: palette.text.tertiary,
      },
      '& .MuiButton-containedSecondary': {
        backgroundColor: palette.primary.main,
        color: palette.text.highlight,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .section-alternate': {
        '& .section-alternate__content': {
          paddingInline: '0 !important',
          '@media(max-width: 600px)': {
            paddingInline: '40px !important',
          },
        },
        '@media(min-width: 900px)': {
          height: 200,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          paddingInline: '90px !important',
        },
      },
      '& .hero-static-bg': {
        backgroundColor: `${palette.background.hero1} !important`,
      },
      '& .section-header__title': {
        color: palette.text.primary,
        fontWeight: 500,
        fontFamily: 'Montserrat !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        '@media screen and (max-width: 600px)': {
          fontSize: '36px !important',
          letterSpacing: '-0.72px !important',
        },
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '32px !important',
          lineHeight: '36px !important',
          letterSpacing: '-0.64px !important',
        },
      },
      '& .section-header__subtitle': {
        color: palette.text.secondary,
        fontWeight: 400,
        fontSize: '20px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.8px !important',
      },
      '& .hero-button-wrapper': {
        '& .MuiButton-label': {
          fontSize: '16px !important',
        },
        '@media(min-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'right !important',
        },
        '@media(max-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'center !important',
        },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .checkout-innner-container': {
        '& .customDetailsContainer': {
          '& .MuiButtonBase-root': {
            textTransform: 'none !important',
          },
        },
      },
      '& .hero-header-title': {
        fontFamily: 'Montserrat !important',
        fontSize: '48px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.96px !important',
        fontWeight: 500,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'Inter Display !important',
        fontSize: '18px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.secondary.main,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.primary.main} !important`,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .MuiButton-contained': {
        backgroundColor: palette.text.highlight,
        color: palette.text.primary,
      },
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        maxWidth: 'unset',
      },
      '& .header-container': {
        margin: '0',
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
      '& .faq-link': {
        fontSize: '15px !important',
      },
      '& .accorion__item-title-container': {
        '& .MuiTypography-subtitle1': {
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 500,
        },
      },
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.32px !important',
        fontWeight: 400,
      },
    },
    '& .faq-contact-section': {
      background: `${palette.primary.light} !important`,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      paddingInline: '80px !important',
      '@media(max-width: 1024px) and (min-width: 900px)': {
        paddingInline: '20px !important',
      },
      '@media(max-width: 900px) and (min-width: 600px)': {
        paddingInline: '40px !important',
      },
      '@media(max-width: 600px) ': {
        paddingInline: '20px !important',
      },
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
      '& .contact-card-title': {
        fontFamily: 'Montserrat !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        '@media(max-width: 600px)': {
          fontSize: '32px !important',
          letterSpacing: '-0.64px !important',
        },
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '36px !important',
          letterSpacing: '-0.72px !important',
        },
      },
      '& .contact-card-subtitle': {
        color: palette.text.primary,
        fontSize: '24px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.72px !important',
        maxWidth: 'unset',
        '@media(max-width: 900px)': {
          fontSize: '22px !important',
          lineHeight: '26px !important',
          letterSpacing: '-0.66px !important',
        },
      },
      '& .contact-img-wrapper': {
        padding: '0px !important',
        marginRight: '8px !important',
      },
      '& .provider-contact-details': {
        fontSize: '18px !important',
        fontFamily: 'Inter Display !important',
        lineHeight: '18px !important',
        letterSpacing: '-0.36px !important',
        color: palette.text.primary,
      },
      '& .provider-contact-link': {
        color: palette.text.primary,
        fontSize: 24,
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        fontFamily: 'Montserrat !important',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        maxWidth: '100%',
        paddingTop: '5px',
        '@media(max-width: 600px)':{
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
        }
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'Montserrat',
        fontWeight: 500,
      },
    },

    '& .success-wrapper': {
      marginTop: 120,
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.primary.light,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      maxWidth: '598px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.surface.light,
      },
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.border ,
        color: palette.background.border,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.text.alternate,

      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        fill: `${palette.text.alternate} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
      },

      // Active step - outlined circle with number (no fill)
      '&.MuiStepIcon-active': {
        fill: 'transparent !important',
        color: palette.text.alternate,
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.alternate,
        },
      },

      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.alternate, // Dark text on transparent background
        },
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,

      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },

      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: `${palette.background.border} !important`,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      },
    },

    '& .stepperItems': {
      marginTop: 24,
    },

    '& .footer-wrapper': {
      backgroundColor: palette.background.footer,
      paddingInline: '40px !important',
      '@media(max-width: 700px)': {
        paddingInline: '10px !important',
      },
    },
  },
};
